<template>
  <div class="page-wrapper">
    <div class="card">

      <!-- HEADER -->
      <h2 class="page-title">🗳 Master Pools</h2>

      <!-- FORM TAMBAH / EDIT -->
      <div class="form-row">
        <input
          v-model="form.name"
          type="text"
          placeholder="Nama pool (contoh: pool 1)"
          class="input"
        />

        <button @click="savePoll" class="btn-primary">
          {{ form.id ? "Update" : "Simpan" }}
        </button>
      </div>

      <!-- SEARCH -->
      <div class="search-row">
        <input
          v-model="search"
          type="text"
          placeholder="🔍 Cari pool..."
          class="input search"
        />

        <button @click="search=''" class="btn-secondary">
          Reset
        </button>
      </div>

      <!-- TABLE -->
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Nama</th>
              <th>Status</th>
              <th class="right">Aksi</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="p in filteredPolls" :key="p.id">
              <td class="bold">{{ p.name }}</td>

              <!-- STATUS -->
              <td>
                <span
                  :class="Number(p.is_active) === 1
                    ? 'status active'
                    : 'status inactive'"
                >
                  {{ Number(p.is_active) === 1 ? "Aktif" : "Nonaktif" }}
                </span>
              </td>

              <!-- ACTION -->
              <td class="right">
                <button @click="editPoll(p)" class="btn-link edit">
                  Edit
                </button>

                <button
                  @click="togglePoll(p.id)"
                  class="btn-link danger"
                >
                  {{ Number(p.is_active) === 1 ? "Nonaktifkan" : "Aktifkan" }}
                </button>

                <button
                  @click="confirmDelete(p)"
                  class="btn-link danger"
                >
                  Hapus
                </button>
              </td>
            </tr>

            <!-- EMPTY -->
            <tr v-if="filteredPolls.length === 0">
              <td colspan="3" class="empty">
                Poll tidak ditemukan
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "PollsList",

  data() {
    return {
      polls: [],
      search: "",

      form: {
        id: null,
        name: ""
      }
    };
  },

  mounted() {
    this.fetchPolls();
  },

  computed: {
    filteredPolls() {
      const q = this.search.toLowerCase();
      return this.polls.filter(p =>
        p.name.toLowerCase().includes(q)
      );
    }
  },

  methods: {
    // ================= FETCH DATA =================
    async fetchPolls() {
      const res = await fetch("/api/polls/get_polls.php");
      const json = await res.json();

      this.polls = json.data || [];
    },

    // ================= EDIT =================
    editPoll(p) {
      this.form = {
        id: p.id,
        name: p.name
      };
    },

    // ================= CREATE / UPDATE =================
    async savePoll() {
      if (!this.form.name.trim()) {
        alert("Nama poll wajib diisi");
        return;
      }

      const url = this.form.id
        ? "/api/polls/update.php"
        : "/api/polls/create.php";

      await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(this.form)
      });

      // reset form
      this.form = { id: null, name: "" };

      // refresh list
      this.fetchPolls();
    },

    // ================= TOGGLE ACTIVE =================
    async togglePoll(id) {
      await fetch("/api/polls/toggle.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id })
      });

      this.fetchPolls();
    },

    // ================= DELETE =================
    async confirmDelete(poll) {
      const ok = confirm(
        `⚠️ Yakin mau hapus poll:\n\n"${poll.name}"?\n\nData tidak bisa dikembalikan.`
      );

      if (!ok) return;

      await fetch("/api/polls/delete.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: poll.id })
      });

      this.fetchPolls();
    }
  }
};
</script>

<style scoped>
.page-wrapper {
  padding: 24px;
  max-width: 1000px;
  margin: auto;
}

.card {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 14px rgba(0,0,0,0.05);
}

.page-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 20px;
}

/* FORM */
.form-row {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.search-row {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.input {
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 14px;
  width: 100%;
}

.input.search {
  max-width: 260px;
}

/* BUTTON */
.btn-primary {
  background: #3b82f6;
  color: #fff;
  border-radius: 10px;
  padding: 10px 18px;
  font-weight: 600;
  white-space: nowrap;
}

.btn-primary:hover {
  background: #2563eb;
}

.btn-secondary {
  background: #f3f4f6;
  border-radius: 10px;
  padding: 10px 16px;
}

.btn-link {
  font-weight: 500;
  margin-left: 8px;
  border: none;
  background: none;
  cursor: pointer;
}

.btn-link.edit {
  color: #2563eb;
}

.btn-link.danger {
  color: #dc2626;
}

/* TABLE */
.table-wrapper {
  border-top: 1px solid #eee;
  margin-top: 12px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead th {
  text-align: left;
  padding: 14px 10px;
  font-size: 14px;
  color: #555;
}

tbody td {
  padding: 14px 10px;
  border-top: 1px solid #f0f0f0;
  font-size: 14px;
}

.right {
  text-align: right;
}

.bold {
  font-weight: 500;
}

.status {
  font-weight: 600;
}

.status.active {
  color: #16a34a;
}

.status.inactive {
  color: #6b7280;
}

.empty {
  text-align: center;
  padding: 24px;
  color: #9ca3af;
}
</style>
